import scorecardActions from "./actions";

const initialState = {
  scoreCardData: [],
  generatedScoreData:[]
};

const scorecardReducer = (state = initialState, action) => {
  switch (action.type) {
    case scorecardActions.SET_SCORE_DATA:
      return {
        ...state,
        scoreCardData: action.payload,
      };
      case scorecardActions.SET_GENERATED_SCORE_DATA:
      return {
        ...state,
        generatedScoreData: action.payload,
      };
    default:
      return state;
  }
};

export default scorecardReducer;
